module.exports = __webpack_public_path__ + "static/aspect-ratio-mobile-c370cf040de224b7228bc322535b4186.jpg";